import { render, staticRenderFns } from "./interview-edit.vue?vue&type=template&id=2260e013&scoped=true"
import script from "./interview-edit.vue?vue&type=script&lang=ts"
export * from "./interview-edit.vue?vue&type=script&lang=ts"
import style0 from "./interview-edit.vue?vue&type=style&index=0&id=2260e013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2260e013",
  null
  
)

export default component.exports